export default {"src":"/_next/static/media/whytman_logo.1feef64b.svg","height":163,"width":298,"blurWidth":0,"blurHeight":0};